import { inject } from '@angular/core';
import { ReportingApiService } from '../reporting-api.service';
import { normalizeReportsConvertedPath } from './reports-converted-path.util';

interface ReportsConvertedRequestOptions {
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  query?: unknown;
  body?: unknown;
  headers?: Record<string, string>;
  responseType?: 'json' | 'text' | 'blob';
}

export abstract class ReportsConvertedApiBaseService {
  protected abstract readonly basePath: string;
  private readonly reportingApiService = inject(ReportingApiService);

  protected request<T>(path: string, options: ReportsConvertedRequestOptions = {}): Promise<T> {
    return this.reportingApiService.request<T>(this.getBasePath(path), options);
  }

  protected get<T>(path: string, query?: unknown): Promise<T> {
    return this.request<T>(path, { method: 'GET', query });
  }

  protected post<T>(path: string, body?: unknown): Promise<T> {
    return this.request<T>(path, { method: 'POST', body });
  }

  protected put<T>(path: string, body?: unknown): Promise<T> {
    return this.request<T>(path, { method: 'PUT', body });
  }

  protected delete<T>(path: string): Promise<T> {
    return this.request<T>(path, { method: 'DELETE' });
  }

  private getBasePath(path: string): string {
    const normalizedBasePath = normalizeReportsConvertedPath(this.basePath);
    const normalizedPath = normalizeReportsConvertedPath(path);

    return normalizedPath ? `${normalizedBasePath}/${normalizedPath}` : normalizedBasePath;
  }
}
